var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoPartStopCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#F0F4F8",
    stroke: "#D9E3EC",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_52689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 20.3C12.6701 20.3 11.589 19.2189 11.589 17.8889V14.7777H10.1113V17.8889C10.1113 20.0355 11.8535 21.7777 14.0001 21.7777C16.1468 21.7777 17.889 20.0355 17.889 17.8889V14.7777H16.4113V17.8889C16.4113 19.2189 15.3301 20.3 14.0001 20.3ZM14.7779 17.1111V10.8889H13.2224V17.1111H14.7779ZM10.1113 10.1111V13.2222H11.589V10.1111C11.589 8.78108 12.6701 7.69996 14.0001 7.69996C15.3301 7.69996 16.4113 8.78108 16.4113 10.1111V13.2222H17.889V10.1111C17.889 7.96441 16.1468 6.22219 14.0001 6.22219C11.8535 6.22219 10.1113 7.96441 10.1113 10.1111Z",
    fill: "#101214"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_52689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6667,
    height: 18.6667,
    fill: "white",
    transform: "matrix(0 -1 1 0 4.66681 23.3333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoPartStopCircle);
export default __webpack_public_path__ + "static/media/two-part-stop-circle.a871bafa1aa7291699955fe148cf6dff.svg";
export { ForwardRef as ReactComponent };